"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WrappedPropertyBase_1 = require("./WrappedPropertyBase");
var WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
var functions_1 = require("./functions");
var defaultValue_1 = require("../JSchema/defaultValue");
var setData_1 = require("../JSchema/setData");
var fixDateFormat_1 = require("../JSchema/fixDateFormat");
var getRuleMessage_1 = require("../JSchema/getRuleMessage");
var WrappedPropertyObject = /** @class */ (function (_super) {
    __extends(WrappedPropertyObject, _super);
    function WrappedPropertyObject(dest, parent, propName, schema, options) {
        var _this = _super.call(this, dest, parent, propName, schema, options) || this;
        var internal = _this._internal;
        internal.schemaprops = schema.properties;
        internal.cacheProp = {};
        var mparent = (internal.mparent = parent[propName]);
        (0, functions_1.initVue)(_this, _this._internal);
        if (internal.schemaprops) {
            if (mparent === undefined) {
                var defvalue = (0, defaultValue_1.default)(schema, true);
                options.Vue.set(parent, propName, defvalue);
                internal.mparent = mparent = parent[propName];
            }
            // tworzenie property
            // if (mparent != null) {
            createProps(_this, internal, options);
            /*
            const required: any = schema.required || [];
            for (const key in internal.schemaprops) {
              if (internal.schemaprops.hasOwnProperty(key)) {
                const element = internal.schemaprops[key];
                if ((element.fieldRequired === undefined) && (required.indexOf(key) > -1)) {
                  element.fieldRequired = true;
                }
                let type = element.type;
      
      
      
                // setTimeout(function() {
                // self.wrapProperty(obj, mparent, key, element);
      
                // let proptime = (new Date()).getTime();
                if (this._options.wrapAll) {
                  const prop: IWrappedProperty = (this[key] = new Ctor[type](this, mparent, key, element, options));
                  if (this.$dirty) {
                    prop.$dirty = true;
                  }
                } else {
                  Object.defineProperty(this, key, {
                    enumerable: true,
                    get() {
                      let prop = internal.cacheProp[key];
                      if (prop === undefined) {
      
                        prop = internal.cacheProp[key] = new Ctor[type](this, mparent, key, element, options);
                        if (this.$dirty) {
                          prop.$dirty = true;
                        }
                      }
                      return prop;
                    }
                  });
      
                  // console.log('prop time 1', key, (new Date()).getTime() - proptime);
      
                  // trzeba utworzyć tabele jeśli są undefined w modelu
      
                  if (type === 'array' || mparent[key] === undefined || anyCalc(element)) {
                    const prop = internal.cacheProp[key] = new Ctor[type](this, mparent, key, element, options);
                    if (this.$dirty) {
                      prop.$dirty = true;
                    }
                  }
                }
      
                // console.log('prop time', key, (new Date()).getTime() - proptime);
              }
            }
            */
            // }
        }
        return _this;
    }
    /**
     * ustawienie wartości wmodelu
     *
     * @param {*} value nowa wartość
     * @param {string} [path] ścieżka gdy ustawiany jest element podrżedny
     * @param {boolean} [fixArraySize] czy ustawiać nową dłguośc tablicy
     * @returns {boolean}
     * @memberof WrappedPropertyObject
     */
    WrappedPropertyObject.prototype.$setData = function (value, path, fixArraySize) {
        return (0, setData_1.default)(this._internal.schema, this.$model, value, path, 0, this._options.Vue, fixArraySize);
    };
    /**
     * sprawdza obiekt pod kątem błedów
     *
     * @param {*} [value] wejściowy obiekt
     * @param {boolean} [skipDirty] czy ma nie zaznaczać pola jako dirty
     * @returns {(string | null)} komunikat błędu lub null gdy błedu nie ma
     * @memberof WrappedPropertyObject
     */
    WrappedPropertyObject.prototype.$validate = function (value, skipDirty) {
        if (this.$disabled) {
            return null;
        }
        if (!skipDirty) {
            this.$dirty = true;
        }
        if (!this.$parent) {
            // self.startDirty = true;
            this._internal.options.startDirty = true;
        }
        if (value === undefined) {
            value = this.$model;
        }
        if (value === null) {
            // console.timeEnd('(number)$validate');
            if (this.$schema.fieldRequired) {
                var message = (0, getRuleMessage_1.getRuleMessage)(this._internal, 'required', value, this.$schema);
                this.$validateResult = {
                    validation: 'required',
                    message: message,
                    expected: true
                };
                return message;
            }
            return null;
        }
        return null;
        /*
            if (value === undefined) {
                value = mparent;
            }
            */
    };
    /**
     * sprawdza obiekt i wszystkie jego elementy pod kątem błędów
     *
     * @param {boolean} [skipDirty] czy ma nie zaznaczać pola jako dirty
     * @param {IWrappedProperty[]} result
     * @returns {IWrappedProperty[]} lista elementów zawierających błedy
     * @memberof WrappedPropertyObject
     */
    WrappedPropertyObject.prototype.$validateAll = function (skipDirty, result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$disabled) {
            return result;
        }
        if (this.$validate(undefined, skipDirty) !== null) {
            result.push(this);
        }
        if (!skipDirty) {
            this.$dirty = true;
        }
        // tslint:disable-next-line: forin
        for (var key in this._internal.schemaprops) {
            var item = this[key];
            if (item) {
                item.$validateAll(skipDirty, result);
            }
        }
        return result;
    };
    /**
     * sprawdza obiekt pod kątem ostrzeżeń
     *
     * @param {*} [value] obiekt
     * @param {boolean} [skipDirty] czy nie zaznaczać $dirty
     * @param {string[]} [checkResult]
     * @returns {string[]} lista ostrzeżeń lub pusta tablica
     * @memberof WrappedPropertyObject
     */
    WrappedPropertyObject.prototype.$check = function (value, skipDirty, checkResult) {
        if (this.$disabled) {
            return (this.$checkResult = []);
        }
        if (!skipDirty) {
            this.$dirty = true;
        }
        if (!this.$parent) {
            // self.startDirty = true;
            this._internal.options.startDirty = true;
        }
        return (this.$checkResult = []);
        /*
            if (value === undefined) {
                value = mparent;
            }
            */
    };
    /**
     * sprawdza obiekt i wszystkie jego elementy pod kątem ostrzeżeń
     *
     * @param {boolean} [skipDirty] czy nie zaznaczać $dirty
     * @param {IWrappedProperty[]} result
     * @returns {IWrappedProperty[]} lista pól zawierających ostrzeżenia
     * @memberof WrappedPropertyObject
     */
    WrappedPropertyObject.prototype.$checkAll = function (skipDirty, result) {
        if (this.$disabled) {
            return [];
        }
        if (result === undefined) {
            result = [];
        }
        if (!skipDirty) {
            this.$dirty = true;
        }
        for (var key in this._internal.schemaprops) {
            if (this[key]) {
                this[key].$checkAll(skipDirty, result);
            }
        }
        return result;
    };
    /**
     * czyści status $dirty na wszystkich właściwościach obiektu
     *
     * @memberof WrappedPropertyObject
     */
    WrappedPropertyObject.prototype.$reset = function () {
        // tslint:disable-next-line: forin
        for (var key in this._internal.cacheProp) {
            var prop = this._internal.cacheProp[key];
            if (prop !== undefined) {
                prop.$reset();
            }
        }
        this.$dirty = false;
        if (!this.$parent) {
            this._internal.options.startDirty = false;
        }
    };
    /**
     * list elementów "dotkniętych" przez użytkownika
     *
     * @param {any[]} result
     * @returns {any[]}
     * @memberof WrappedPropertyObject
     */
    WrappedPropertyObject.prototype.$dirtyList = function (result) {
        if (result === undefined) {
            result = [];
        }
        // tslint:disable-next-line: forin
        for (var key in this._internal.cacheProp) {
            var prop = this._internal.cacheProp[key];
            if (prop) {
                prop.$dirtyList(result);
            }
        }
        return result;
    };
    /**
     * naprawia format daty we wszytkich właściwościach obiektu
     *
     * @returns {number}
     * @memberof WrappedPropertyObject
     */
    WrappedPropertyObject.prototype.$fixDateFormat = function () {
        return (0, fixDateFormat_1.default)(this._internal.schema, this.$model, this._options.Vue);
    };
    WrappedPropertyObject.prototype.$fixFormat = function () {
        return (0, fixDateFormat_1.default)(this._internal.schema, this.$model, this._options.Vue);
    };
    /**
     * niszczenie obiektu i zwalnianie zasobów
     *
     * @memberof WrappedPropertyObject
     */
    WrappedPropertyObject.prototype.$destroy = function () {
        // debugger;
        removeProps(this, this._internal, this._options);
        _super.prototype.$destroy.call(this);
    };
    /**
     * zdarzenie przed zmianą ścieżki
     *
     * @protected
     * @memberof WrappedPropertyObject
     */
    WrappedPropertyObject.prototype.beforePathChange = function () {
        _super.prototype.beforePathChange.call(this);
        // tslint:disable-next-line: forin
        for (var key in this._internal.cacheProp) {
            var prop = this._internal.cacheProp[key];
            if (prop) {
                prop.beforePathChange();
            }
        }
    };
    /**
     * zdarzenie po zmianie ścieżki
     *
     * @protected
     * @memberof WrappedPropertyObject
     */
    WrappedPropertyObject.prototype.afterPathChange = function () {
        // tslint:disable-next-line: forin
        for (var key in this._internal.cacheProp) {
            var prop = this._internal.cacheProp[key];
            if (prop) {
                prop.afterPathChange();
            }
        }
        _super.prototype.afterPathChange.call(this);
    };
    return WrappedPropertyObject;
}(WrappedPropertyBase_1.default));
exports.default = WrappedPropertyObject;
/**
 * funkcja do tworzenie property na podstawie schematu
 *
 * @param {WrappedPropertyObject} obj
 * @param {IObjectInternal} internal
 * @param {IOptions} options
 * @returns
 */
function createProps(obj, internal, options) {
    var mparent = internal.mparent;
    var schema = internal.schema;
    var required = schema.required || [];
    var _loop_1 = function (key) {
        if (internal.schemaprops.hasOwnProperty(key)) {
            var element_1 = internal.schemaprops[key];
            if (element_1.fieldRequired === undefined && required.indexOf(key) > -1) {
                element_1.fieldRequired = true;
            }
            var type_1 = element_1.type;
            if (options.wrapAll) {
                var prop = (obj[key] = internal.cacheProp[key] = new WrappedPropertyCtor_1.default[type_1](obj, mparent, key, element_1, options));
                if (obj.$dirty && !prop.$disabled) {
                    prop.$dirty = true;
                }
                Object.seal(prop);
            }
            else {
                Object.defineProperty(obj, key, {
                    enumerable: true,
                    // configurable: true,
                    configurable: false,
                    get: function () {
                        var prop = internal.cacheProp[key];
                        // tslint:disable-next-line: no-conditional-assignment
                        if ((mparent = obj.$model) === null) {
                            if (prop) {
                                prop.$destroy();
                                delete internal.cacheProp[key];
                            }
                            return null;
                        }
                        if (prop === undefined) {
                            prop = internal.cacheProp[key] = new WrappedPropertyCtor_1.default[type_1](obj, mparent, key, element_1, options);
                            if (this.$dirty && !prop.$disabled) {
                                prop.$dirty = true;
                            }
                        }
                        Object.seal(prop);
                        return prop;
                    }
                });
                // console.log('prop time 1', key, (new Date()).getTime() - proptime);
                // trzeba utworzyć tabele jeśli są undefined w modelu
                if (mparent) {
                    if (type_1 === 'array' || mparent[key] === undefined || (0, functions_1.anyCalc)(element_1)) {
                        var prop = (internal.cacheProp[key] = new WrappedPropertyCtor_1.default[type_1](obj, mparent, key, element_1, options));
                        if (obj.$dirty && !prop.$disabled) {
                            prop.$dirty = true;
                        }
                    }
                }
            }
            // console.log('prop time', key, (new Date()).getTime() - proptime);
        }
    };
    for (var key in internal.schemaprops) {
        _loop_1(key);
    }
}
/**
 * funkcja usuwania wszystkich property
 *
 * @param {WrappedPropertyObject} obj
 * @param {IObjectInternal} internal
 * @param {IOptions} options
 */
function removeProps(obj, internal, options) {
    var mparent = internal.mparent;
    var schema = internal.schema;
    var required = schema.required || [];
    for (var key in internal.schemaprops) {
        if (internal.schemaprops.hasOwnProperty(key)) {
            var cprop = internal.cacheProp[key];
            if (cprop) {
                cprop.$destroy();
                delete internal.cacheProp[key];
                // delete obj[key];
            }
        }
        // console.log('prop time', key, (new Date()).getTime() - proptime);
    }
}
WrappedPropertyCtor_1.default.object = WrappedPropertyObject;
//# sourceMappingURL=WrappedPropertyObject.js.map